import { useModel } from "./hooks";
export function ModelRenderer(_a) {
    var model = _a.model, render = _a.render;
    var result = useModel(model);
    return render(result);
}
//# sourceMappingURL=render.js.map